<template>
  <div class="project container">
    <div class="content">
      <p v-scroll-reveal>
        Get started
      </p>
      <h3 v-scroll-reveal="{ delay: 100 }">
        Do you have a project in mind?<br />Here are a few things we could help
        you with.
      </h3>
      <h2 v-scroll-reveal="{ delay: 200 }">
        <vue-typer
          :shuffle="true"
          :text="[
            'Move to headless',
            'Get started with PWA',
            'Expand to a new market',
            'Increase performance',
            'Increase conversion',
            'Re-think your design',
            'Integrate your ERP',
            'Run A/B tests',
            'Migrate your old platform',
            'Perform user tests',
            'Sell more',
            'Get into China',
            'Remove bottlenecks',
            'Plan for the future',
            'Lower costs',
            'Support your team',
            'Improve your CMS',
            'Run benchmark tests'
          ]"
        />
      </h2>
    </div>
  </div>
</template>

<script>
import { VueTyper } from "vue-typer";
export default {
  name: "StartProject",
  props: {
    header: String
  },
  components: {
    VueTyper
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";

.project {
  display: flex;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  //background:$black;
  color: inherit;
  overflow: hidden;
  padding-bottom: 5vh !important;
  video {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.5;
    display: none;
  }
  .content {
    position: relative;
    z-index: 1;
    width: 100%;
    h3,
    h2 {
      @include headline-small;
      font-weight: 400;
      width: 50%;
      margin-bottom: 5%;
      padding-right: 3vw;
      color: inherit;
      * {
        color: inherit;
      }
    }
    h2 {
      padding-left: 4vw;
      &:before {
        content: "—";
        position: absolute;
        left: 0;
      }
    }
  }
}
@media (max-width: $mobile) {
  .project {
    .content {
      h3,
      h2 {
        width: 100%;
      }
      h2 {
        padding-left: 40px;
      }
    }
  }
}
</style>
<style lang="scss">
.vue-typer {
  .custom {
    &.char {
      color: inherit;
      &.selected {
        background-color: blue;
        color: white;
      }
    }
    &.caret {
      background-color: white;
    }
  }
}
</style>
